/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bp_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boiling Point at Pressure Calculator`)
};

const es_bp_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Punto de Ebullición a Presión`)
};

const de_bp_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siedepunkt-bei-Druck-Rechner`)
};

const nl_bp_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kookpunt-bij-drukcalculator`)
};

const fr_bp_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur de point d'ébullition sous pression`)
};

const it_bp_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore punto di ebollizione alla pressione`)
};

const pt_br2_bp_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Ponto de Ebulição por Pressão`)
};

const pt_bp_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Ponto de Ebulição à Pressão`)
};

const ja_bp_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`圧力別沸点計算機`)
};

const zh_bp_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`压力下沸点计算器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bp_tool_name = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bp_tool_name(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bp_tool_name", locale)
	if (locale === "en") return en_bp_tool_name(inputs)
	if (locale === "es") return es_bp_tool_name(inputs)
	if (locale === "de") return de_bp_tool_name(inputs)
	if (locale === "nl") return nl_bp_tool_name(inputs)
	if (locale === "fr") return fr_bp_tool_name(inputs)
	if (locale === "it") return it_bp_tool_name(inputs)
	if (locale === "pt-BR") return pt_br2_bp_tool_name(inputs)
	if (locale === "pt") return pt_bp_tool_name(inputs)
	if (locale === "ja") return ja_bp_tool_name(inputs)
	return zh_bp_tool_name(inputs)
};